import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class WeightItemService {
  private url: string;

  constructor(
    private http: HttpClient
  ) {
    this.url = GLOBAL.url;
  }

  private createHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
  }

  private buildSearchParams(params: any): string {
    return Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');
  }

  create(token: any, task: any): Observable<any> {
    const params = {
      json: JSON.stringify(task),
      authorization: token
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/new?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }
  getOptimi(   token: any,
    page: any = 1,
    perPage: any,
    filter: any,
    task: any,
    sort: any = '',
    sortby: any = '',
    bypo: boolean = false,
    from: any = null,
    to: any = null,
    filtros: any[] = []
  ): Observable<any> {
    const params = {
      authorization: token,
      json: JSON.stringify(task)
    };
    const headers = this.createHeaders();

    let url: string;
    if (!bypo) {
      url = `${this.url}/weightitem/listbylocationoptimization/${filter}?page=${page}&perpage=${perPage}&asc=0`;
    } else {
      url = `${this.url}/weightitem/listbylocationoptimization/${filter}?page=${page}&perpage=${perPage}&asc=0`;
    }

    if (sortby) {
      if (sort === "") {
        sort = "DESC";
      }
      url += `&order=${sort}&orderby=${filtros[sortby].key}`;
    }

    if (from) {
      url += `&from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }

    for (const filtro of filtros) {
      if (filtro && filtro.value) {
        url += `&${filtro.key}=${filtro.value}`;
        if (filtro.type) {
          url += `&${filtro.key_type}=${filtro.type}`;
        }
      }
    }

    return this.http.post<any>(url, this.buildSearchParams(params), { headers });
  }
  getAll(
    token: any,
    page: any = 1,
    perPage: any,
    filter: any,
    task: any,
    sort: any = '',
    sortby: any = '',
    bypo: boolean = false,
    from: any = null,
    to: any = null,
    filtros: any[] = []
  ): Observable<any> {
    const params = {
      authorization: token,
      json: JSON.stringify(task)
    };
    const headers = this.createHeaders();

    let url: string;
    if (!bypo) {
      url = `${this.url}/weightitem/listbylocation/${filter}?page=${page}&perpage=${perPage}&asc=0`;
    } else {
      url = `${this.url}/weightitem/listbypoanddepto/${task.search}/${filter}?page=${page}&perpage=${perPage}&asc=0`;
    }

    if (sortby) {
      if (sort === "") {
        sort = "DESC";
      }
      url += `&order=${sort}&orderby=${filtros[sortby].key}`;
    }

    if (from) {
      url += `&from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }

    for (const filtro of filtros) {
      if (filtro && filtro.value) {
        url += `&${filtro.key}=${filtro.value}`;
        if (filtro.type) {
          url += `&${filtro.key_type}=${filtro.type}`;
        }
      }
    }

    return this.http.post<any>(url, this.buildSearchParams(params), { headers });
  }

  getReceived(task: any): Observable<any> {
    const token = JSON.parse(localStorage.getItem('token'));
    const params = {
      authorization: token,
      json: JSON.stringify(task)
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/getreceived`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  getOlder(): Observable<any> {
    const token = JSON.parse(localStorage.getItem('token'));
    const params = { authorization: token };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/listbylocationolders?asc=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  getDepartmentProcessedByDate(task: any,location = ""): Observable<any> {
    const token = JSON.parse(localStorage.getItem('token'));
    const params = {
      authorization: token,
      json: JSON.stringify(task),
      location: location
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/departmentprocessedbydate`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  getProcessedByDateCurrentDepartment(task: any): Observable<any> {
    const token = JSON.parse(localStorage.getItem('token'));
    const params = {
      authorization: token,
      json: JSON.stringify(task)
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/processedbydatecurrentdepartment`,
      this.buildSearchParams(params),
      { headers }
    );
  }


  getProcessedByDate(task: any): Observable<any> {
    const token = JSON.parse(localStorage.getItem('token'));
    const params = {
      authorization: token,
      json: JSON.stringify(task)
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/processedbydate`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  getSearch(token: any, page: any = 1, perPage: any, task: any): Observable<any> {
    const params = {
      authorization: token,
      json: JSON.stringify(task)
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/search?page=${page}&perpage=${perPage}`,
      this.buildSearchParams(params),
      { headers }
    );
  }


  getItems(token: any, page: any = 1): Observable<any> {
    const params = { authorization: token };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/list?page=${page}`,
      this.buildSearchParams(params),
      { headers }
    );
  }
/*  */
  getItemsByFather(token: any, page: any, id: any, task: any = null): Observable<any> {
    let params;
    if (task !== null) {
      params = {
        json: JSON.stringify(task),
        authorization: token
      };
    } else {
      params = { authorization: token };
    }
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/listbyfather/${id}?page=${page}`,
      this.buildSearchParams(params),
      { headers }
    );
  }
  getItemsByFatherV2(token: any, id: any, task: any = null,filtros = [],page = 1,perpage = 10,): Observable<any> {
    let params;
    if (task !== null) {
      params = {
        json: JSON.stringify(task),
        authorization: token
      };
    } else {
      params = { authorization: token };
    }
    const headers = this.createHeaders();
    let url =`${this.url}/weightitem/listbyfathertable/${id}?page=${page}&perpage=${perpage}`;
    for (let filtro of filtros) {      
      if (filtro && filtro.value) {
        console.log(filtro.key);
        url = url + "&" + filtro.key + "=" + filtro.value;
  
        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;
        }
      }
    }
    return this.http.post<any>(
      url,
      this.buildSearchParams(params),
      { headers }
    );
  }
/*  */
  getItemsAvailablesByFather(token: any, id: any, hideprocessed: any = 0): Observable<any> {
    const task = {
      onlyprocessed: hideprocessed
    };
    const params = {
      json: JSON.stringify(task),
      authorization: token
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/listavailablesbyfather/${id}?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  getItem(token: any, id: any, page: any = 1): Observable<any> {
    const params = { authorization: token };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/detail/${id}?page=${page}`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  changelocation(token: any, task: any, id: any): Observable<any> {
    const params = {
      json: JSON.stringify(task),
      authorization: token
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/changelocation/${id}?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  update(token: any, task: any, id: any): Observable<any> {
    const params = {
      json: JSON.stringify(task),
      authorization: token
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/edit/${id}?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  deleteItem(token: any, id: any): Observable<any> {
    const params = { authorization: token };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/remove/${id}?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }
  
  changeBulkItems(token: any, task: any, id: any): Observable<any> {
    const params = {
      json: JSON.stringify(task),
      authorization: token
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/changebulkitems/${id}?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  transactionSummary(token: any, id: any): Observable<any> {
    const params = { authorization: token };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/transactionsummary/${id}?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }

  searchByPO(po: any, api: any, warehouse: any): Observable<any> {
    const headers = this.createHeaders();

    return this.http.get<any>(
      `https://www.itaderp.com/backend/search-weight/search-weight-po.php?po=${po}&apikey=${api}&warehouse=${warehouse}`,
      { headers }
    );
  }

  searchByDate(date1: any, date2: any, api: any): Observable<any> {
    const headers = this.createHeaders();

    return this.http.get<any>(
      `https://www.itaderp.com/backend/search-weight/search-weight.php?date1=${date1}&date2=${date2}&apikey=${api}`,
      { headers }
    );
  }

  searchByDateCompany(date1: any, date2: any, api: any, company: any, warehouse: any): Observable<any> {
    const headers = this.createHeaders();

    return this.http.get<any>(
      `https://www.itaderp.com/backend/search-weight/search-weight-company.php?date1=${date1}&date2=${date2}&company=${company}&apikey=${api}&warehouse=${warehouse}`,
      { headers }
    );
  }

  searchESGReporting(token: any, task: any): Observable<any> {
    const params = {
      json: JSON.stringify(task),
      authorization: token
    };
    const headers = this.createHeaders();

    return this.http.post<any>(
      `${this.url}/weightitem/esgreporting?page=1`,
      this.buildSearchParams(params),
      { headers }
    );
  }


}
